export default __webpack_public_path__ + "static/media/harry-r.9cdd191c.png";